"use client";
import { ConfigProvider } from "antd";
import React from "react";

const AntDesignProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigProvider
      prefixCls="ant"
      iconPrefixCls="anticon"
      theme={{
        components: {
          Button: {},
          Input: {
            lineWidth: 1,
          },
          Menu: {
            itemColor: "#101828",
            itemSelectedBg: "#EFF6FF",
            itemBorderRadius: 6,
            itemHeight: 48,
          },
          Form: {
            labelHeight: 16,
            verticalLabelPadding: "0 0 4px 0",
            itemMarginBottom: 0,
          },
          Card: {
            borderRadiusLG: 8,
            borderRadius: 8,
            bodyPadding: 0,
          },
          Collapse: {
            headerPadding: "12px 12px 12px 12px",
            borderlessContentPadding: "0 12px 12px 12px",
          },
        },
        token: {
          borderRadius: 8,
          colorBorder: "#D2D5DA",
          colorPrimary: "#2563EB",
          colorBgSpotlight: "#ffffff",
          colorBgContainerDisabled: "#EFF6FF",
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntDesignProvider;
